import { html, LitElement } from "lit-element";
import log from "loglevel";
export class RenderDebug extends LitElement {
    constructor() {
        super(...arguments);
        this.name = "";
    }
    static get properties() {
        return {
            name: { type: String },
        };
    }
    firstUpdated() {
        log.warn("first render", this.name);
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html ``;
    }
}
customElements.define("jh-render-debug", RenderDebug);
//# sourceMappingURL=renderDebug.js.map